import { defineStore } from 'pinia';
import { getMarketingData } from '@/js/quests/dashboard/services/api';
import { MarketingData, Placeholder } from '@/js/types/marketingData';

interface NotificationItem {
    title: string;
    subtitle: string;
    route: string;
}

interface MarketingStoreState {
    marketingData: MarketingData,
    notificationData: NotificationItem,
    bannerLink: string,
    headerLink: string,
}

export const useMarketingStore = defineStore('marketing', {
    state: (): MarketingStoreState => ({
        marketingData: null,
        notificationData: null,
        bannerLink: '',
        headerLink: '',
    }),
    actions: {
        constructLinks() {
            if (!this.marketingData) return;

            if (this.marketingData.header && this.marketingData.header.length > 0) {
                this.headerLink = this.processTextWithPlaceholders(this.marketingData.header[0]);
            }

            if (this.marketingData.banner && this.marketingData.banner.length > 0) {
                this.bannerLink = this.processTextWithPlaceholders(this.marketingData.banner[0]);
            }

            if (this.marketingData.notification && this.marketingData.notification.length > 0) {
                this.notificationData = {
                    title: this.marketingData.notification[0].title,
                    subtitle: this.marketingData.notification[0].subtitle,
                    route: this.marketingData.notification[0].route.url,
                };
            }
        },

        processTextWithPlaceholders(item: { text: string; placeholders: Record<string, Placeholder> }): string {
            let processedText = item.text;

            Object.entries(item.placeholders).forEach(([placeholder, data]) => {
                const linkHtml = `<a href="${data.route.url}">${data.text}</a>`;
                processedText = processedText.replace(placeholder, linkHtml);
            });

            return processedText;
        },
        async fetchMarketingData() {
            const { data } = await getMarketingData();
            this.marketingData = data;

            this.constructLinks();
        },
    },
});
